export default __webpack_public_path__ + "static/media/imgTrilhaFormativa.071f0ba5.png";